import { TrendingUp, TrendingDown } from 'lucide-react'
import { cn } from '@/shared/utils'
import type { ReactNode } from 'react'

interface Props {
  title: string; value: string | number; change?: number
  icon?: ReactNode; color?: 'blue'|'green'|'amber'|'red'|'purple'|'teal'
  className?: string
}
const colorMap = {
  blue: { bg:'bg-brand-50', icon:'bg-brand-100 text-brand-600' },
  green: { bg:'bg-green-50', icon:'bg-green-100 text-green-600' },
  amber: { bg:'bg-brand-50', icon:'bg-brand-100 text-brand-600' },
  red: { bg:'bg-red-50', icon:'bg-red-100 text-red-600' },
  purple: { bg:'bg-purple-50', icon:'bg-purple-100 text-purple-600' },
  teal: { bg:'bg-teal-50', icon:'bg-teal-100 text-teal-600' },
}

export function StatCard({ title, value, change, icon, color='blue', className }: Props) {
  const c = colorMap[color]
  return (
    <div className={cn('bg-white rounded-xl border border-gray-100 p-5 flex items-start justify-between gap-4', className)}>
      <div>
        <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1">{title}</p>
        <p className="text-2xl font-bold text-gray-900 font-display">{value}</p>
        {change !== undefined && (
          <div className={cn('flex items-center gap-1 mt-1 text-xs font-semibold', change >= 0 ? 'text-green-600' : 'text-red-500')}>
            {change >= 0 ? <TrendingUp size={12}/> : <TrendingDown size={12}/>}
            {Math.abs(change)}%
          </div>
        )}
      </div>
      {icon && <div className={cn('w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0', c.icon)}>{icon}</div>}
    </div>
  )
}
